import apiClient from './api';
import { IFilterSettings } from '../Types/FilterTypes';
import { convertFilterSettingsToQuery, queryParamsToString } from './filterHelpers';

export const taxonomyAPI = {
  // Categories
  getAllCategories: (filterSettings?: IFilterSettings) => {
    if (filterSettings) {
      const queryParams = convertFilterSettingsToQuery(filterSettings);
      const queryString = queryParamsToString(queryParams);
      return apiClient.get(`/api/admin/taxonomy/categories?${queryString}`);
    }
    return apiClient.get('/api/admin/taxonomy/categories');
  },
  getCategory: (id: string) => apiClient.get(`/api/admin/taxonomy/categories/${id}`),
  createCategory: (data: any) => apiClient.post('/api/admin/taxonomy/categories', data),
  updateCategory: (id: string, data: any) => apiClient.patch(`/api/admin/taxonomy/categories/${id}`, data),
  deleteCategory: (id: string) => apiClient.delete(`/api/admin/taxonomy/categories/${id}`),
  
  // Options
  getCategoryOptions: (categoryId: string) => apiClient.get(`/api/admin/taxonomy/categories/${categoryId}/options`),
  getOption: (id: string) => apiClient.get(`/api/admin/taxonomy/options/${id}`),
  createOption: (categoryId: string, data: any) => apiClient.post(`/api/admin/taxonomy/categories/${categoryId}/options`, data),
  updateOption: (id: string, data: any) => apiClient.patch(`/api/admin/taxonomy/options/${id}`, data),
  deleteOption: (id: string) => apiClient.delete(`/api/admin/taxonomy/options/${id}`),
};
